"use client";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
const d = ({
  title: r,
  titleId: i,
  desc: n,
  descId: o,
  ...l
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": o,
    ...l,
    children: [
      n ? /* @__PURE__ */ e("desc", { id: o, children: n }) : null,
      r ? /* @__PURE__ */ e("title", { id: i, children: r }) : null,
      /* @__PURE__ */ e(
        "g",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          children: /* @__PURE__ */ e("path", { d: "M11.9999 15c-3.1701 0-5.9892 1.5306-7.784 3.906-.3863.5112-.5795.7668-.5732 1.1123.005.2669.1725.6036.3825.7684C4.297 21 4.6737 21 5.4271 21h13.1455c.7534 0 1.1301 0 1.4019-.2133.21-.1648.3776-.5015.3825-.7684.0063-.3455-.1869-.6011-.5731-1.1123-1.7948-2.3754-4.614-3.906-7.784-3.906M11.9999 12c2.4852 0 4.5-2.0147 4.5-4.5s-2.0148-4.5-4.5-4.5c-2.4853 0-4.5 2.0147-4.5 4.5s2.0147 4.5 4.5 4.5" })
        }
      )
    ]
  }
);
export {
  d as default
};
